export function setupNewsletterButton() {
  const button = document.querySelector('.to-newsletter');
  const input = document.getElementById('input_1_1');

  if (button && input) {
    button.addEventListener('click', () => {
      // Hace scroll suave hasta el input
      input.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // Pone el foco en el input
      input.focus();
    });
  }
}
